import { GridColDef, GridRowsProp } from '@mui/x-data-grid-pro';

import { EditRemoveBtn } from 'components/buttons';
import { PanelGrid } from 'components/grid';
import { Block } from 'components/page';
import { useQueryBiList } from 'pages/bi/hooks';
import { ConfigBi } from 'pages/bi/types';

/**
 * Transforma os dados recebidos da API em um formato adequado para o DataGrid.
 */
const getRows = (rows: ConfigBi[] | undefined): GridRowsProp => {
    if (!rows) return [];

    return rows.map((row) => ({
        id: row.idConfigBi,
        dsTipoPainelBi: row.tipoPainelBi?.dsTipoPainelBi,
        dsTipoLoja: row.tipoLoja?.map((tipoLoja) => tipoLoja.dsTipoLoja).join(', ') || '',
        dsConfigBi: row.dsConfigBi,
        nrSequenciaConfigBi: row.nrSequencia,
        vlAltura: row.vlAltura,
        vlAlturaMobile: row.vlAlturaMobile,
        fgAtivo: row.fgAtivo,
    }));
};

export function BiGrid() {
    const { data, isFetching, refetch } = useQueryBiList();
    const rows = getRows(data?.data);

    const columns: GridColDef[] = [
        { field: 'dsTipoLoja', headerName: 'Tipo de loja', minWidth: 80, flex: 1 },
        { field: 'dsTipoPainelBi', headerName: 'Tipo do painel', minWidth: 80, flex: 1 },
        { field: 'dsConfigBi', headerName: 'Descrição', minWidth: 110, flex: 1 },
        { field: 'nrSequenciaConfigBi', headerName: 'Posição', minWidth: 80, type: 'number' },
        { field: 'vlAltura', headerName: 'Altura', minWidth: 110, type: 'number', valueFormatter: (value) => `${value}px` },
        {
            field: 'vlAlturaMobile',
            headerName: 'Altura mobile',
            type: 'number',
            minWidth: 110,
            valueFormatter: (value) => (value ? `${value}px` : ''),
        },
        { field: 'fgAtivo', headerName: 'Ativo', type: 'boolean', minWidth: 80 },
        {
            field: 'acoes',
            align: 'center',
            headerAlign: 'center',
            headerName: 'Ações',
            filterable: false,
            sortable: false,
            hideable: false,
            disableColumnMenu: true,
            minWidth: 60,
            renderCell: ({ row }) => <EditRemoveBtn id={row.id} sx={{ p: 1.5 }} />,
        },
    ];

    return (
        <Block>
            <PanelGrid rows={rows} rowsCount={data?.total || 0} reload={refetch} loading={isFetching} columns={columns} />
        </Block>
    );
}
